import React, { Component } from 'react';

import './index.scss';
import logo from 'assets/logos/logo.svg';
import desktop_exit from 'assets/icons/login-x-icon.svg';
import {getMediaPath} from "../../../app/functions";
import Loader from '../../common/loader';
class Basic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            sendAgainLoading: false,
            actionLoading: false,
            displayText: this.props.text || 'General Message Text',
            displaySendAgainText: this.props.sendAgainText || '',
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
        this.handleSendAgain = this.handleSendAgain.bind(this);
        this.actionLocked = false;
        this.sendAgainLocked = false;
    }

    static getDerivedStateFromProps(props, state) {
        if(props.popup_id !== state.popup_id) {
            return {animation_class: 'active'}
        }
        return {};
    }

    componentDidMount() {
        this.animateIn();
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }

    animateOut(callback, afterClose) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            if (typeof this.props.handleClose === 'function') {
                this.props.handleClose();
            }
            if (typeof afterClose === 'function') {
                afterClose();
            }
        }, 200);
    }

    handleOnClick = async () =>{
        if (this.actionLocked) return;
        this.actionLocked = true;
        this.setState({ actionLoading: true });
        let result;
        try {
            if (typeof this.props.action === 'function'){
                result = await Promise.resolve(this.props.action());
            }
        } catch (e) {
            console.log('error', e);
        } finally {
            this.animateOut(undefined, () => {
                if (typeof this.props.afterAction === 'function') {
                    try {
                        this.props.afterAction(result);
                    } catch (e) {
                        console.log('afterAction error', e);
                    }
                }
            });
        }
    };

    handleSendAgain = async () => {
        if (this.sendAgainLocked) return;
        if (this.state.sendAgainLoading) return;
        if (typeof this.props.sendAgainAction !== 'function') return;
        this.sendAgainLocked = true;
        this.setState({ sendAgainLoading: true });
        let result;
        try {
            result = await Promise.resolve(this.props.sendAgainAction());
        } catch (e) {
            console.log('error', e);
        } finally {
            this.sendAgainLocked = false;
            this.setState({ sendAgainLoading: false });
            if (typeof this.props.afterSendAgainAction === 'function') {
                try {
                    const { text, hideSendAgain } = this.props.afterSendAgainAction(result);
                    if (text) {
                        this.setState({ displayText: text });
                    }
                    if (hideSendAgain) {
                        this.setState({ displaySendAgainText: '' });
                    }
                } catch (e) {
                    console.log('afterSendAgainAction error', e);
                }
            }
        }
    };

    render() {

        const { className = '' } = this.props;

        const text = this.state.displayText;

        const btnText = this.props.btnText !== undefined ? this.props.btnText : 'אישור'

        const normalizedSendAgainText = typeof this.state.displaySendAgainText === 'string' ? this.state.displaySendAgainText.trim() : '';
        const shouldShowSendAgain = normalizedSendAgainText.length > 0;
        const hasSendAgainHandler = typeof this.props.sendAgainAction === 'function';

        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper basic_popup " + this.state.animation_class} onClick = { (e) => e.stopPropagation() }>
                    <button className = "x_close_icon"
                            onClick = { () => this.animateOut() }
                    >
                        <img src={getMediaPath(desktop_exit)} alt='' />
                    </button>
                    <div className = "popup_content">
                        <div className={`${className ? ' '+className:''} text`}>{ text }</div>
                        <button className="accept-button"
                                onClick = { this.handleOnClick }
                                disabled={this.state.actionLoading}
                                aria-label="אישור">{btnText}</button>
                        {shouldShowSendAgain && (
                            <button
                                className="send-again-button"
                                onClick={this.handleSendAgain}
                                disabled={this.state.sendAgainLoading || !hasSendAgainHandler}
                                aria-label={normalizedSendAgainText}
                            >
                                {normalizedSendAgainText}
                            </button>
                        )}
                    </div>
                    {(this.state.actionLoading || this.state.sendAgainLoading) && <Loader className="popup-loader" />}
                </div>
            </div>
        )
    }
}

export default Basic;
